// API error `reason` -> translated copy. The backend sends a machine-readable
// `reason` next to its English `error`; a reason the client has no copy for
// falls through to that English string, so a new reason needs its key here in
// the same release (root CLAUDE.md, rule 1).
const REASON_KEYS = {
  plan_feature_locked: "common.errorReasons.planFeatureLocked",
  segment_requires_push: "common.errorReasons.segmentRequiresPush",
  segment_unknown: "common.errorReasons.segmentUnknown",
  invalid_range: "common.errorReasons.invalidRange",
  export_type_unknown: "common.errorReasons.exportTypeUnknown",
  message_not_pending: "common.errorReasons.messageNotPending",
};

const PLAN_NAME_KEYS = {
  starter: "pricing.tier.starter.name",
  growth: "pricing.tier.growth.name",
  advanced: "pricing.tier.advanced.name",
};

export function getApiErrorReasonMessage(data, t) {
  const key = REASON_KEYS[data?.reason];
  if (!key) return null;

  if (data.reason === "plan_feature_locked") {
    const planKey = PLAN_NAME_KEYS[data.required_plan];
    return planKey
      ? t("common.errorReasons.planFeatureLockedPlan", { plan: t(planKey) })
      : t(key);
  }
  return t(key);
}

// Everything an API error says, as a list for an inline message: a known
// reason's translated copy, else the `errors` array the Rails validations send
// (or a lone `error` string), else the translated fallback. A network failure
// has no response body and lands on the fallback.
export function getApiErrorMessages(error, t, fallbackKey) {
  const data = error?.response?.data;
  const reasonMessage = getApiErrorReasonMessage(data, t);
  if (reasonMessage) return [reasonMessage];

  const raw = data?.errors ?? data?.error;
  const flat =
    raw && typeof raw === "object" && !Array.isArray(raw)
      ? Object.values(raw).flat()
      : [].concat(raw ?? []);
  const messages = flat.filter(
    (message) => typeof message === "string" && message.trim(),
  );

  return messages.length > 0 ? messages : [t(fallbackKey)];
}
